import React from "react";
import "./Common_white_header.css";
import { useNavigate, useLocation, Link } from "react-router-dom";

function Common_white_header({ headingText,historyTitle,historyLink }) {
  const navigate = useNavigate();
  const location = useLocation();

  // Check if current path matches
  const showHistory =
    location.pathname === "/withdraw" ||
    location.pathname === "/deposite";

  return (
    <div className="Common_white_header">
      <span className="back_btn" onClick={() => navigate(-1)}>
        ←
      </span>

      <h3>{headingText}</h3>

      {showHistory && (
        <Link to={historyLink}>

        <div className="history_heading_holder">
          {historyTitle}
        </div>
        </Link>
      )}
    </div>
  );
}

export default Common_white_header;